// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

declare global {
  interface Event {}
}

export { AbortError } from "./AbortError.js";
export { AbortSignalLike } from "./AbortSignalLike.js";
